import { c as _c } from "react/compiler-runtime";
import type { DeviceKind } from '../../types';
type FeedbackProps = {
  children: string;
  deviceKind: DeviceKind;
  top: number;
};
const Feedback = t0 => {
  const $ = _c(8);
  const {
    children,
    deviceKind,
    top
  } = t0;
  const t1 = `${top + 8}px`;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      top: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <div className="bg-black/50 z-[1] py-2 px-3 rounded text-center"><p className="text-label-2 text-white fp-text">{children}</p></div>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== deviceKind || $[5] !== t2 || $[6] !== t3) {
    t4 = <div className="flex items-center justify-center absolute w-full" data-device={deviceKind} style={t2}>{t3}</div>;
    $[4] = deviceKind;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default Feedback;